import {
  FieldValuesFilterType,
  FieldValuesFilterVO,
} from '@mc/data-filter-react';

export const isFieldFilterFilled = (data?: FieldValuesFilterVO) => {
  if (!data) {
    return false;
  }

  switch (data.filterType) {
    case FieldValuesFilterType.VALUES:
      return data.values && data.values.length > 0;
    default:
      throw new Error(`Unknown filter type: ${data.filterType}`);
  }
};
